import { Presentation, ImageWithMetadata } from '@features/powerpoint';
import { Campaign } from '@features/campaigns';
import { DEFAULT_FILENAME } from '@features/executive-report/utils';
import { createSharedPresentationConfig as createSharedPresentationConfigV1 } from '@features/executive-report/utils/shared-presentation-config';
import { FormSchema as FormSchemaV1 } from '../form-schema';
import { RslReport } from '@features/campaigns/subdomains/rsl';
import { VisitMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { SubdimensionsByName } from '@features/reports/subdomains/visitation/domain/dimensions';
import { ValueInput } from '@utils/formattersV2';
import { buildSlideMasters } from '@features/executive-report/utils/slide-masters';
import { buildSlidesV2 } from './build-slides-v2';
import { createSharedPresentationConfigV2 } from '@features/executive-report/utils/shared-presentation-config-v2';
import { buildSlidesV1 } from './build-slides-v1';
import { FormSchema as FormSchemaV2 } from '../domain/v2/form-schema';
import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';

export type BuildReportOptions = {
  brandLogo: ImageWithMetadata | null;
  campaign: Pick<Campaign, 'id' | 'name' | 'startDate' | 'endDate' | 'adSpend'>;
  report: RslReport;
  midCampaignReport: RslReport | null;
  iroas: number | null;
  visitMetrics: VisitMetrics;
  topVisitSubdimensionsByName: SubdimensionsByName;
  costPerIncrementalVisit: ValueInput;
  campaignAnalyticsReport: CampaignAnalyticsReport | null;
} & (
  | {
      designVersion: 'v1';
      customFields: FormSchemaV1;
    }
  | {
      designVersion: 'v2';
      customFields: FormSchemaV2;
    }
);

export const buildPresentation = (
  options: BuildReportOptions
): Presentation => {
  const { slides, createSharedPresentationConfig } = (() => {
    if (options.designVersion === 'v1') {
      return {
        slides: buildSlidesV1(options),
        createSharedPresentationConfig: createSharedPresentationConfigV1,
      };
    }
    return {
      slides: buildSlidesV2(options),
      createSharedPresentationConfig: (
        brandLogo: BuildReportOptions['brandLogo']
      ) => createSharedPresentationConfigV2(buildSlideMasters(brandLogo)),
    };
  })();

  return {
    ...createSharedPresentationConfig(options.brandLogo),
    filename: [options.campaign.name, DEFAULT_FILENAME].join(' - '),
    slides,
  };
};
